import React, { Fragment } from 'react'
import { upsellsTypes } from '../upsell/upsellsTypes'

export const bagList = [
	{
		upsell: upsellsTypes.UPSELL1,
		name: '100+ new presets',
		isSelected: false,
	},
	{
		upsell: upsellsTypes.UPSELL2,
		name: (
			<Fragment>
				Professional
				<br /> Beautification Tools
			</Fragment>
		),
		isSelected: false,
	},
	{
		upsell: upsellsTypes.UPSELL3,
		name: 'Animal You Look Like',
		isSelected: false,
	},
	{
		upsell: upsellsTypes.UPSELL4,
		name: 'Your Ethnicity Estimate',
		isSelected: false,
	},
]
